// Mapping the keys between the form and the user profile
export const userDataMapping = [
  {
    userProfileKey: "first-name",
    formInputId: "form_input_custom1",
  },
  {
    userProfileKey: "last-name",
    formInputId: "form_input_custom2",
  },
  {
    userProfileKey: "email",
    formInputId: "form_input_custom3",
  },
  {
    userProfileKey: "company",
    formInputId: "form_input_custom4",
  },
  {
    userProfileKey: "business-type",
    formInputId: "form_input_custom5",
  },
  {
    userProfileKey: "job-levelseniority",
    formInputId: "form_input_custom6",
  },
  {
    userProfileKey: "job-function",
    formInputId: "form_input_custom7",
  },
  {
    userProfileKey: "title",
    formInputId: "form_input_custom8",
  },
  {
    userProfileKey: "country",
    formInputId: "form_input_custom9",
  },
  {
    userProfileKey: "state",
    formInputId: "form_input_custom11",
  },
  {
    userProfileKey: "phone",
    formInputId: "form_input_custom12",
  },
];

export const WEBINAR_REG_MESSAGES = {
  existing: "You are already registered.",
  success: "Thank you for registering.",
}

export const WEBINAR_SIGN_UP_SID = "ZI2404WREG";